module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/fontello.woff?e8b45a3ca4f505402a069ecf7e7cbbc1";